import React from "react"
import PropTypes from "prop-types"

const SVG = ({ className, size }) => (
  <svg viewBox="0 0 497 497" className={className} {...size}>
    <path
      d="M248.5 45.668L62.178 86.137l32.386 105.04c10.506 34.077 42 57.323 77.659 57.323l76.277 40.469 76.277-40.469c35.659 0 67.153-23.247 77.659-57.323l32.386-105.04z"
      fill="#ffbdd7"
    />
    <path
      d="M202.223 248.5c-35.659 0-67.153-23.247-77.659-57.323L92.178 86.137h-30l32.385 105.04c10.506 34.077 42 57.323 77.659 57.323z"
      fill="#ff97c0"
    />
    <path
      d="M248.5 288.969L24.201 329.437l32.386 105.04c10.506 34.076 42 57.323 77.659 57.323h228.507c35.659 0 67.153-23.247 77.659-57.323l32.386-105.04z"
      fill="#b0ebce"
    />
    <path
      d="M24.201 329.438l32.386 105.04c10.506 34.076 42 57.323 77.659 57.323h30c-35.659 0-67.153-23.247-77.659-57.323l-32.386-105.04z"
      fill="#60d9a7"
    />
    <path
      d="M150.432 410.87a7.5 7.5 0 0 1-7.5-7.5v-18.845c0-4.142 3.357-7.5 7.5-7.5s7.5 3.358 7.5 7.5v18.845a7.5 7.5 0 0 1-7.5 7.5zM346.569 410.87a7.5 7.5 0 0 1-7.5-7.5v-18.845c0-4.142 3.357-7.5 7.5-7.5s7.5 3.358 7.5 7.5v18.845a7.5 7.5 0 0 1-7.5 7.5zM248.5 422.088a41.797 41.797 0 0 1-31.51-14.351 7.5 7.5 0 0 1 11.309-9.856c5.099 5.851 12.462 9.207 20.201 9.207s15.103-3.356 20.201-9.207a7.501 7.501 0 0 1 11.309 9.856 41.798 41.798 0 0 1-31.51 14.351z"
      fill="#423e4f"
    />
    <path
      d="M457.253 52.938l-8.338-20.732A43.081 43.081 0 0 0 408.945 5.2H88.055a43.081 43.081 0 0 0-39.97 27.006l-8.338 20.732c-6.39 15.887 5.307 33.199 22.431 33.199h372.643c17.125 0 28.822-17.312 22.432-33.199z"
      fill="#f9d888"
    />
    <path
      d="M69.747 52.938l8.338-20.732A43.082 43.082 0 0 1 118.055 5.2h-30a43.08 43.08 0 0 0-39.97 27.006l-8.338 20.732c-6.39 15.887 5.307 33.199 22.431 33.199h30c-17.124 0-28.82-17.312-22.431-33.199z"
      fill="#ffbe73"
    />
    <path
      d="M160.292 167.186a7.5 7.5 0 0 1-7.5-7.5v-16.95c0-4.142 3.357-7.5 7.5-7.5s7.5 3.358 7.5 7.5v16.95a7.5 7.5 0 0 1-7.5 7.5zM336.709 167.186a7.5 7.5 0 0 1-7.5-7.5v-16.95c0-4.142 3.357-7.5 7.5-7.5s7.5 3.358 7.5 7.5v16.95a7.5 7.5 0 0 1-7.5 7.5zM248.5 177.276a38.349 38.349 0 0 1-28.91-13.167 7.5 7.5 0 0 1 11.309-9.856c4.443 5.098 10.859 8.022 17.602 8.022s13.159-2.924 17.602-8.022a7.5 7.5 0 0 1 11.309 9.855 38.347 38.347 0 0 1-28.912 13.168z"
      fill="#423e4f"
    />
    <path
      d="M495.23 296.239l-8.338-20.732a43.08 43.08 0 0 0-39.97-27.006H50.078a43.081 43.081 0 0 0-39.97 27.006L1.77 296.239c-6.39 15.887 5.307 33.199 22.431 33.199h448.597c17.125-.001 28.821-17.312 22.432-33.199z"
      fill="#f9d888"
    />
    <path
      d="M31.77 296.238l8.338-20.732a43.08 43.08 0 0 1 39.97-27.006h-30a43.08 43.08 0 0 0-39.97 27.006L1.77 296.238c-6.39 15.888 5.307 33.199 22.431 33.199h30c-17.124.001-28.82-17.311-22.431-33.199z"
      fill="#ffbe73"
    />
  </svg>
)

SVG.propTypes = {
  size: PropTypes.shape({
    width: PropTypes.number,
    height: PropTypes.number,
  }),
}

export default SVG
